import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 18,
	viewBox: "0 0 17 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.4583 9V13.9583H3.54167V9H2.125V13.9583C2.125 14.7375 2.7625 15.375 3.54167 15.375H13.4583C14.2375 15.375 14.875 14.7375 14.875 13.9583V9H13.4583Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.95692 7.16542L7.7915 5.33792L7.7915 12.1875L9.20817 12.1875L9.20817 5.33792L11.0428 7.16542L12.0415 6.16667L8.49984 2.625L4.95817 6.16667L5.95692 7.16542Z",
		fill: "currentColor"
	})]
});
export default SvgUpload;
